module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Light.dec88e5f.eot";